import { getAppVersion } from '@/tool';
import conutryarr from '@/components/common/country.js'

const isGlobal = getAppVersion() === 'GLOBAL'

const  getCountry = () => {
  const browserLang = (navigator.appName=='Netscape' ? navigator.language : navigator.userLanguage).toLowerCase()
  const country = {
    'zh-hk':'HK',
    'ja':'JP',
    'ko':'KR',
    'en-sg':'SG',
    'ar-sa':'SA',
    'ar-iq':'IQ',
    'zh-tw':'TW',
    'th':'TH',
    'ar-ae':'US',
    'en-za':'ZA',
    'de':'DE',
    'de-de':'DE',
    'pt':'PT',
    'pt-br':'PT',
    'pt-pt':'PT',
    'ru':'RU',
    'es':'ES',
    'de-ch':'CH',
    'fr-ch':'CH',
    'de-ch':'CH',
    'en-gb':'GB',
    'en-gb-oxendict':'GB',
    'en-au':'AU',
  }[browserLang] || 'US'
  return conutryarr.find(v => v.content === country)
}

console.log('getCountrygetCountry', getCountry());

const app = {
  state: {
    accept: localStorage.getItem('acceptis') ? true : false,
    conutry: getCountry(),
    alertinfo:{type:'error',content:'',showis:false},
    // 是否是国际版
    isGlobal,
    showLoading: false,
  },

  mutations: {
    SET_ACCEPT: (state, accept) => {
      state.accept = accept
    },
    SET_COUNTRY: (state, conutry) => {
      state.conutry = conutry
    },
    SET_ALERT: (state, alertinfo) => {
      state.alertinfo = alertinfo
    },
    SET_SHOWLOADING: (state, showLoading) => {
      state.showLoading = showLoading
    },
  },

  actions: {

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          dispatch('GenerateRoutes', data) // 动态修改权限后 重绘侧边菜单
          resolve()
        })
      })
    },
    setShowLoading({ commit }, s) {
      commit('SET_SHOWLOADING', s)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/app.js